<template>
    <div class="modal modal--confirm" v-bind:class="{ 'is-open' : isOpen }">
        <div class="modal__dialog">
            <div class="modal__content">
                {{ __('Are you sure you wish to move this tile?') }}
                <div class="has-margin-t30 has-text-left">
                    <label class="form__label" v-bind:for="'moveToStartdesk' + tile.id">{{ __('Move to startdesk') }}</label>
                    <select class="form__control" v-bind:id="'moveToStartdesk' + tile.id"
                            v-model="selectedStartdesk"
                    >
                        <option v-for="startdesk in myStartdesks" v-bind:value="startdesk.id">{{ startdesk.name }}</option>
                    </select>

                    <nav class="has-margin-t15 is-clearfix">
                        <a class="btn is-primary is-pulled-left" v-on:click="move">{{ __('Move') }}</a>
                    </nav>

                    <span class="view__separator has-margin-t30">
                        <span>{{ __('or') }}</span>
                    </span>

                    <label class="form__label" v-bind:for="'moveToNewStartdesk' + tile.id">{{ __('Add to a new startdesk') }}</label>
                    <input class="form__control is-large" v-bind:id="'moveToNewStartdesk' + tile.id" type="text" autocomplete="off"
                           v-bind:placeholder="__('Enter startdesk name')"
                           v-model="startdeskName"
                    />

                    <nav class="has-margin-t15 is-clearfix">
                        <a class="btn is-primary is-pulled-left" v-on:click="add">{{ __('Add') }}</a>
                    </nav>

                </div>

                <nav class="has-margin-t30 is-clearfix">
                    <a class="btn is-pulled-right" v-on:click="closeModal">{{ __('Cancel') }}</a>
                </nav>
            </div>
        </div>
        <div class="modal__backdrop" v-on:click="closeModal"></div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            // attach event listeners
            eventBus.$on('open-modal', this.openModal);
        },
        data: function () {
            return {
                isOpen: false,
                selectedStartdesk: null,
                startdeskName: ''
            }
        },
        methods: {
            add: function () {
                eventBus.$emit('show-loader');

                this.$http.post(this.apiUrl + '/startdesks', {
                    name: this.startdeskName,
                    user_id: this.user.id
                }).then(function (response) {
                    this.myStartdesks.push(response.body);

                    this.myStartdesks.sort(function(a, b) {
                        return  a.name.localeCompare(b.name);
                    });

                    let prevStartdeskId = this.tile.startdesk_id;
                    let newStartdeskId = response.body.id;
                    this.$http.patch(this.apiUrl + '/tiles' + '/' + this.tile.id, {
                        startdesk_id: response.body.id
                    }).then(function (response) {
                        eventBus.$emit('hide-loader');

                        eventBus.$emit('show-alert', 'success', this.__('Tile has been successfully added.'));

                        this.closeModal();

                        this.$parent.$parent.paging.to--;
                        this.$parent.$parent.paging.total--;

                        this.$parent.$parent.selectedTiles = this.$parent.$parent.selectedTiles.filter(function (tile) {
                            return this.tile != tile;
                        }.bind(this));

                        this.$parent.$parent.tiles = this.$parent.$parent.tiles.filter(function (tile) {
                            return this.tile.id != tile.id
                        }.bind(this));
                        
                        if (newStartdeskId && newStartdeskId != '') {
                            this.$http.post(this.apiUrl + '/startdesks/' + newStartdeskId + '/screenshot');
                        }
                        
                        if (prevStartdeskId && prevStartdeskId != '') {
                            this.$http.post(this.apiUrl + '/startdesks/' + prevStartdeskId + '/screenshot');
                        }
                    }, function (response) {
                        if (response.status == 422 && response.body.errors) {
                            this.errors = response.body.errors;
                        }

                        eventBus.$emit('hide-loader');

                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('There were some errors validation the form. Please review and correct them.')
                        );

                        this.closeModal();
                    }.bind(this));
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );

                    this.closeModal();
                }.bind(this));
            },
            closeModal: function () {
                this.isOpen = false;
            },
            confirm: function () {
                eventBus.$emit('confirm', this.id);

                this.closeModal();
            },
            move: function () {
                eventBus.$emit('show-loader');

                let prevStartdeskId = this.tile.startdesk_id;
                this.$http.patch(this.apiUrl + '/tiles' + '/' + this.tile.id, {
                    startdesk_id: this.selectedStartdesk
                }).then(function (response) {
                    this.getStartdesks();

                    eventBus.$emit('hide-loader');

                    eventBus.$emit('show-alert', 'success', this.__('Tile has been successfully moved.'));

                    this.closeModal();

                    this.$parent.$parent.paging.to--;
                    this.$parent.$parent.paging.total--;

                    this.$parent.$parent.selectedTiles = this.$parent.$parent.selectedTiles.filter(function (tile) {
                        return this.tile != tile;
                    }.bind(this));

                    this.$parent.$parent.tiles = this.$parent.$parent.tiles.filter(function (tile) {
                        return this.tile.id != tile.id
                    }.bind(this));
                    
                    if (this.selectedStartdesk && this.selectedStartdesk != '') {
                        this.$http.post(this.apiUrl + '/startdesks/' + this.selectedStartdesk + '/screenshot');
                    }
                    
                    if (prevStartdeskId && prevStartdeskId != '') {
                        this.$http.post(this.apiUrl + '/startdesks/' + prevStartdeskId + '/screenshot');
                    }
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );

                    this.closeModal();
                }.bind(this));
            },
            openModal: function (id) {
                if (this.id == id) {
                    this.isOpen = true;
                }
            }
        },
        props: {
            id: {
                required: true,
                type: [Number, String]
            },
            tile: {
                required: null,
                type: Object
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MoveTile.vue